import { authFetch } from "@/lib/api-client";
import type {
  AdminVendorRow,
  AdminVendorWritePayload,
  VendorContactEmailRow,
} from "@/features/admin/marketplace/types/admin-marketplace.types";

// ─── Reads ─────────────────────────────────────────────────────────────────

export async function fetchAdminVendors(): Promise<AdminVendorRow[]> {
  const { data } = await authFetch<AdminVendorRow[]>(
    "/marketplace/admin/vendors",
  );
  return data;
}

export async function fetchAdminVendor(
  vendorId: string,
): Promise<AdminVendorRow> {
  const { data } = await authFetch<AdminVendorRow>(
    `/marketplace/admin/vendors/${encodeURIComponent(vendorId)}`,
  );
  return data;
}

// ─── Mutations ─────────────────────────────────────────────────────────────

export async function createAdminVendor(
  payload: AdminVendorWritePayload,
): Promise<AdminVendorRow> {
  const { data } = await authFetch<AdminVendorRow>(
    "/marketplace/admin/vendors",
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
  return data;
}

export async function replaceAdminVendor(
  vendorId: string,
  payload: AdminVendorWritePayload,
): Promise<AdminVendorRow> {
  const { data } = await authFetch<AdminVendorRow>(
    `/marketplace/admin/vendors/${encodeURIComponent(vendorId)}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );
  return data;
}

export async function activateAdminVendor(
  vendorId: string,
): Promise<AdminVendorRow> {
  const { data } = await authFetch<AdminVendorRow>(
    `/marketplace/admin/vendors/${encodeURIComponent(vendorId)}/activate`,
    { method: "POST" },
  );
  return data;
}

export async function deactivateAdminVendor(
  vendorId: string,
): Promise<AdminVendorRow> {
  const { data } = await authFetch<AdminVendorRow>(
    `/marketplace/admin/vendors/${encodeURIComponent(vendorId)}/deactivate`,
    { method: "POST" },
  );
  return data;
}

// Approving makes an address a live egress target, so the API gates these on
// super-tenant on top of the permission key.

export async function approveVendorContactEmail(
  vendorId: string,
  emailId: string,
): Promise<VendorContactEmailRow> {
  const { data } = await authFetch<VendorContactEmailRow>(
    `/marketplace/admin/vendors/${encodeURIComponent(vendorId)}/contact-emails/${encodeURIComponent(emailId)}/approve`,
    { method: "POST" },
  );
  return data;
}

export async function revokeVendorContactEmail(
  vendorId: string,
  emailId: string,
): Promise<VendorContactEmailRow> {
  const { data } = await authFetch<VendorContactEmailRow>(
    `/marketplace/admin/vendors/${encodeURIComponent(vendorId)}/contact-emails/${encodeURIComponent(emailId)}/revoke`,
    { method: "POST" },
  );
  return data;
}
